import styled from 'styled-components';

export default styled.div`
  text-align: center;
  margin-top: 20px;

  a {
    margin: 0 auto !important;
  }
`;
